/* globals lp,Class */
var ScriptModule = Class.create(
  lp.ModuleBase,
  lp.ModuleElementMethods,
  lp.ModuleElementBuilderMethods,
  {
    beforeCreate: function(page, defaults, options, data) {
      defaults.content.html = data.html;
    }
  }
);

lp.addModule(new ScriptModule(
  {
    type:'lp-script',
    version:'1.0',
    name: 'Javascript',
    defaultName: 'Javascript',
    usageType:'non-visible-page-widget',
    namespace: lp.module.script,
    elementClassName: 'ScriptElement',
    elementBuilderClassName: 'ScriptElementBuilder'
  }
));

module.exports = ScriptModule;



//////////////////
// WEBPACK FOOTER
// ./src/legacy/lp/modules/lp-script/script_module.js
// module id = 585
// module chunks = 0 1